import { BM_CONFIG } from './apps/bm';
import { SS_CONFIG } from './apps/ss';
import type { AppConfig, AppId } from './types';

/**
 * The only place in src/ that reads REACT_APP_APP.
 *
 * An explicit comparison against the literal 'ss', never a cast: any other
 * value — unset, a typo, 'SS' — resolves to bm. A broken flag degrades to
 * bhajanmala.com, never to SGS Satsang served on bhajanmala.com.
 */
export const APP_ID: AppId = process.env.REACT_APP_APP === 'ss' ? 'ss' : 'bm';

export const APP: AppConfig = APP_ID === 'ss' ? SS_CONFIG : BM_CONFIG;
